// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__fkh9W","content":"TermsOfServicePage_content__1GQ_5"};